import makeAccountStatementPopover from "../../../reports2/visitors/viewer/makeAccountStatementPopover.js";
import RowTitleRenderer from "../../../reports2/RowTitleRenderer/RowTitleRenderer.js";

/**
 * Render {@link Report} rows for the {@link BudgetEditorWidget}. The
 * difference with the superclass is that account numbers of account
 * rows are rendered as links. A click on such a link opens a popover
 * allowing the user to go to the account statement page.
 *
 * @param {function} onAccountStatementRedirectionRequest - Will be
 *   called with an account number and a period and should open the
 *   account statement for this account number at this period
 */
export default class BudgetEditorRowTitleRenderer extends RowTitleRenderer {
	constructor({ onAccountStatementRedirectionRequest, periods }) {
		super(...arguments);

		this._onAccountStatementRedirectionRequest =
			onAccountStatementRedirectionRequest;

		this._periods = periods;
	}

	_accountNumberRenderer({ accountRow }) {
		return (html) => {
			let trigger;

			html.span({ klass: "account-number" }, (html) => {
				trigger = html.a(accountRow.getAccountNumber());
			});

			makeAccountStatementPopover({
				trigger,
				accountNumber: accountRow.getAccountNumber(),
				periods: this._periods,
				onAccountStatementRedirectionRequest:
					this._onAccountStatementRedirectionRequest,
			});
		};
	}
}
